<template>
  <div class="agave-info">
    <div class="sticky-top" id="agave-wrapper">
      <h1 id="agave-name">{{ searchResult.name }}</h1>
      <h6 id="agave-label" v-if="searchResult.setName === 'speciesNames'" >{{ $t('species')}}</h6>
      <h6 id="agave-label" v-if="searchResult.setName === 'commonNames'" >{{ searchResult.language }}</h6>
    </div>
    <br />
    <div id="subspecies-container" v-if="searchResult.setName === 'speciesNames'">
      <span @click="onCarrotClick" id="subspecies-label">{{ $t('subspecies')}}</span>
      <img @click="onCarrotClick" :class="{ expanded: subspeciesExpanded }" id="subspecies-arrow" src="@/assets/images/arrow.svg" />
      <div id="subspecies-results" :class="{ expanded: subspeciesExpanded}">
        <div 
          v-for="subspecies in searchResult.subspecies" 
          v-bind:key="subspecies.id"
          class="subspecies-names"  >
          {{ subspecies.name }}
        </div>
      </div>
    </div>
    <div v-if="searchResult.setName === 'speciesNames'" class="agave-heading">{{ $t('commonNames')}}</div>
    <div v-if="searchResult.setName === 'commonNames'" class="agave-heading">{{ $t('speciesNames')}}</div>
    <div class="results-list" 
      v-for="entry in correspondingNames"
      v-bind:key="entry.id"
      @click="navigateToEntry(entry)"> 
      <h4 class="single-result">{{ entry.name }}</h4>
      <img class="link-arrow" src="@/assets/images/arrow-right.svg" />
      <div class="language" v-if="entry.setName === 'commonNames'">{{ entry.language }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgaveInfo",
  components: {},
  computed: {
    sortedArray: function() {
      function compare(a, b) {
        if (a.name < b.name){
          return -1;
      }
        if (a.name > b.name){
          return 1;
        }
        return 0;
      }

      return [...this.agaveSpecies].sort(compare);
    }
  },
  mounted() {
  },
  props: {
    searchResult: Object,
    correspondingNames: Array,
  },
  data() {
    return {
      subspeciesExpanded: false,
    }
  },
  methods: {
    navigateToEntry(clickedLink){
      this.subspeciesExpanded = false;
      this.$emit("searchSelected", clickedLink);

    },
    onCarrotClick(){
      this.subspeciesExpanded = !this.subspeciesExpanded;
    }
  },
  watch: {
    searchResult(newValue){
      this.subspeciesExpanded = false;
      if (newValue.name != ''){
        this.backgroundIsHidden = true;
      }
      window.scrollTo(0,0);
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: "futura";
  margin-top: 20px;
  margin-bottom: 0;
}

span {
  font-family: "avenir";
}

.results-list {
  padding-right: 20px;
  margin-bottom: 10px;
}

.single-result {
  display: inline-block;
}

.single-result:hover, .single-result:active {
  color: grey;
}

.agave-name {
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 0;

}

.link-arrow {
  height: 12px;
  margin-left: 5px;
  margin-bottom: 8px
}

.language {
  font-size: 14px;
  margin-top: -8px;
  margin-bottom: 5px;
  color: grey;
}

.subspecies-names {
  margin-top: 0px;
}


#subspecies-results {
  max-height: 0;
  transition: all 0.25s ease-in-out;
  overflow: hidden;
}

#subspecies-results.expanded {
  max-height: 300px;
}

#subspecies-container {
  margin-top: 5px;
}

#subspecies-label {
  font-size: 14px;
}

#agave-wrapper {
  display: inline-block;
  background: #FFFFF7;
  
}

#agave-label {
  float: right;
  font-size: 14px;
  color: grey;
}

.agave-heading {
  margin-top: 10px;
  margin-bottom: 10px;
  color: grey;
  font-family: "optima";
  font-size: 20px;
  font-weight: 100;
}

#subspecies-arrow {
  height: 12px;
  width: 12px;
  margin-left: 5px;
  transition: .15s;
}

#subspecies-arrow.expanded {
  transform:rotate(90deg);
}

</style>
